import { VERNACULAR_DEFAULT_MESSAGES } from "constants/vernacularConstants";


interface ValidationReturnType{ error: string, hasError: boolean, isLatinDetected?: boolean };

/**
* validation function for email field
* @param email of type string or null
*/
export const validateEmail = (email: string | null, errors?: {required: string, invalid: string}): ValidationReturnType => {
  let error = "";
  let hasError = false;
  /* eslint-disable no-useless-escape */
  const regexEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  if (!email) {
    error = (errors && errors.required) || VERNACULAR_DEFAULT_MESSAGES.THIS_FIELD_IS_REQUIRED;
    hasError = true;
  } else if (!regexEmail.test(String(email)
  .toLowerCase())) {
    error = (errors && errors.invalid) || VERNACULAR_DEFAULT_MESSAGES.EMAIL_NOT_VALID;
    hasError = true;
  } else {
    error = "";
  }

  return {
    error,
    hasError,
  };
};
